import Service from "../Service";

const resource = "MarketSubstances/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },
  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID: requestID },
    });
  },
  list(mktID, requestID) {
    return Service.post(resource + "list", null, {
      params: { mktID: mktID, requestID: requestID },
    });
  },
};
